<fuse-progress-bar></fuse-progress-bar>

@if (fuseConfig.layout.style === 'vertical-layout-1') {
  @if (appService.getState('screenLocked')) {
    <div class="cover-all">
      <img width="250px" src="assets/images/logos/andi_logo_a.png" />
      <button class="mt-32 w-200" mat-flat-button (click)="toggleVisibility()">
        <mat-icon aria-hidden="true">lock_open</mat-icon>
        Sblocca schermo
      </button>
      <button class="mt-16 w-200" mat-flat-button [routerLink]="['/logout']">
        <mat-icon aria-hidden="true">power_settings_new</mat-icon>
        Disconnettiti
      </button>
    </div>
  }
  <vertical-layout-1></vertical-layout-1>
}
